/* prettier-ignore */

import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { RestService } from 'src/app/services/rest.service';

@Injectable({ providedIn: 'root' })
export class GenerateRouteService {
  private router = inject(Router);
  private _restService = inject(RestService);
  private _customRouteService = inject(NewCustomRouteService);
    
  public generateRoute() {
    const data: any = {
      location: this._restService?.device?.location
    }

    this._customRouteService.routeConfig = { 
      ...this._customRouteService.routeConfig, 
      startLocation: data?.location, 
      startPointName: data?.location?.address 
    };

    this._customRouteService.filterAppItems();
    this._customRouteService.generateRoute();
    this.router.navigateByUrl('/custom-route');
    return this.getCurrentRoute();
  }

  public getCurrentRoute(){
    return this._customRouteService.route()?.map(day => {
        return day.points.map(e => {
            if (!e.point) 
                return e;

            const item = {
                id: e.point.id,
                name: {es: e.point.name?.['es'], en: e.point.name?.['en']},
                duration: e.point.duration,
                opening_times: e.point.opening_times,
                always_open: e.point.always_open
            }
            return {
                ...e,
                point: item
            }
        })
    })
  }
}